import React from 'react';
import { connect } from 'react-redux'
import {
    IonRefresher,
    IonRefresherContent,
    withIonLifeCycle,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonList,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonIcon,
    IonLabel,
    IonButton,
    IonPopover,
    IonButtons,
    IonMenuButton, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
    IonBackButton,
    IonBadge,
    IonSearchbar,
    IonDatetime,
    IonFabButton,
    IonFooter,
    IonModal,
    IonText,
    IonCheckbox,
    IonLoading,
    IonToast,
    IonAlert,
    IonAccordionGroup,
    IonAccordion
} from '@ionic/react';
import { ticketOutline, trashOutline, ellipsisVerticalOutline, serverOutline, cart, checkmarkCircle, closeCircle, cubeOutline, createOutline, cash, calendar, barcode, search, funnel, add, closeOutline, checkmarkOutline, personAdd, eyeOutline } from 'ionicons/icons';
import MenuPrincipal from '../../components/menu/MenuPrincipal';
import { getLoginApp, getToken, getPermissions, getNewLogin, getEnabledModules } from '../../utils/functions';
import { initdb } from "../../data_base_local/dataservice";
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import UtilActions from '../../actions/UtilActions';
import ReportsActions from '../../actions/ReportsActions';
import PosActions from '../../actions/PosActions';
import Select from 'react-select'
import {
    queryAllLocations,
    createLocationTest,
    queryAllPermisions,
    queryAllConfiguration,
    createConfiguration,
    getConfigurationById,
    updateConfigurationById,
    createPermission,
    createActivitie
} from "../../data_base_local/dataservice";
import Moment from 'react-moment';
import { DebounceInput } from 'react-debounce-input';
const options2: any = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

interface IProps {
    post_: any;
    get_: any;
    validate_permission_: any;
    get_default: any;
    get_data_module: any;
    setData_: any;
}

interface IState {
    data_default: any;
    ModalShow: any;
    fields: any;
    datalogin: any;
    pages: any;
    pageSize: any;
    total_rows: any;
    searchText: any;
    current_count_data: any;
    alertDestroy: any;
    dataDB: any;
    data_pagin_DB: any;
    dataRegisterDB: any;

    RegistersData: any;
    currencyprimary: any;
    currencysecondary: any,

    slcstatus: any;
    slcv_user: any;
    slcv_status: any;

    isOpenTransactionDate: any;
    isOpenDateStart: any;
    isOpenDateEnd: any;
    DateStart: any;
    DateEnd: any;
    isOpenModalFilterDate: any;

    usersDB: any;
    loading: any;
    response: any;
    simpleToast: any;
}

class RegisterReport extends React.Component<IProps, IState> {
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    ModalcreateEdit: React.RefObject<HTMLIonModalElement>;
    ModalShow: React.RefObject<HTMLIonModalElement>;
    constructor(props: any) {
        super(props)
        this.ModalcreateEdit = React.createRef<HTMLIonModalElement>();
        this.ModalShow = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.state = {
            data_default: props.data_default,
            ModalShow: false,
            fields: {
                id: null,
            },
            datalogin: {},
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false,
            dataDB: [],
            data_pagin_DB: [],
            dataRegisterDB: {},
            currencyprimary: '',
            currencysecondary: '',
            RegistersData: null,
            slcstatus: [],
            slcv_user: null,
            slcv_status: null,

            isOpenTransactionDate: false,
            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false,
            usersDB: [],
            loading: props.loading,
            response: props.response,
            simpleToast: props.simpleToast,

        }

    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            dataDB: nextProps.data.RegistersDB && nextProps.data.RegistersDB ? nextProps.data.RegistersDB : [],
            data_pagin_DB: nextProps.data.data_pagin_RegistersDB && nextProps.data.data_pagin_RegistersDB ? nextProps.data.data_pagin_RegistersDB : [],
            pages: nextProps.data.RegistersDB && nextProps.data.RegistersDB.pages ? nextProps.data.RegistersDB.pages : 0,
            total_rows: nextProps.data.RegistersDB && nextProps.data.RegistersDB.total_rows ? nextProps.data.RegistersDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_RegistersDB ? nextProps.data.data_pagin_RegistersDB.length : 0,
            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',
            currencysecondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencysecondary : '',
            usersDB: nextProps.data.data_default && nextProps.data.data_default.users ? nextProps.data.data_default.users : [],
            simpleToast: nextProps.data.simpleToast,
            response: nextProps.data.response,
            loading: nextProps.data.loading,
            RegistersData: nextProps.data.RegistersData && nextProps.data.RegistersData ? nextProps.data.RegistersData : {},
            ModalShow: nextProps.data.RegistersData && nextProps.data.RegistersData ? true : false,
        });

        if (nextProps.data.view_active == "list_registers") {
            console.log("UNSAFE_componentWillReceiveProps Registers", nextProps);

            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }

        }
    }
    ionViewWillEnter() {
        this.setState({
            pages: 0,
            pageSize: 10,
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    componentDidMount() {
        this.setState({
            slcstatus: [
                { id: 'open', name: 'Abierta' },
                { id: 'close', name: 'Cerrada' },
            ],
            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false,
            datalogin: getLoginApp(),
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({

            user_id: this.state.datalogin.id,
            typeOption: 'get_list_registers',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'list_registers',
            searchText: this.state.searchText,
            user_filter: this.state.slcv_user,
            slcv_status: this.state.slcv_status,
            start: moment(this.state.DateStart, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
            end: moment(this.state.DateEnd, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
        }, "api/list_registers");
    }

    render_data(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'>
                            {
                                row.status == 'open' ?
                                    <IonBadge color={"success"} style={{ color: '#ffffff' }}>{row.id} {'Abierta'}</IonBadge>
                                    : <IonBadge color={"danger"} style={{ color: '#ffffff' }}>{row.id} {'Cerrada'}</IonBadge>
                            }
                        </label> <br />
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={calendar} /> </strong> {row.created_at ? moment(row.created_at).format('DD-MM-YYYY HH:mm') : ''} / {row.closed_at ? moment(row.closed_at,).format('DD-MM-YYYY HH:mm') : ''}</label> <br />
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={personAdd} /> {row.added_by}</strong>


                        </label>
                    </IonCol>

                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small' onClick={(e) => this.getRegisterData(row)}>
                            <div>
                                <IonIcon
                                    color="#ffffff"
                                    slot="icon-only"
                                    icon={eyeOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>

                    </IonCol>
                </IonRow>
            </div >
        );
    }

    getRegisterData(row: any) {
        this.props.get_({
            user_id: this.state.datalogin.id,
            id: row.id,
            typeOption: 'getRegisterData',
            view_active: 'list_registers',
        }, "api/getRegisterData");
    }

    dismissModalRegisterData() {
        this.props.setData_({ RegistersData: null });
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    changeFilterDate(e: any) {

        let DateStart: any = null;
        let DateEnd: any = null;

        if (e.target.value == 'hoy') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'ayer') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
        } else if (e.target.value == 'ultimo_7') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(6, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'este_mes') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('month').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('month').format("YYYY-MM-DD");
        } else if (e.target.value == 'este_ano') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        } else if (e.target.value == 'ano_pasado') {
            DateStart = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        }

        this.setState({
            isOpenDateStart: false,
            DateStart: DateStart,
            isOpenDateEnd: false,
            DateEnd: DateEnd,
            isOpenModalFilterDate: false,
            pages: 0,
            pageSize: 10,
        });

        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    handleChangeState(event: any) {
        console.log(event.target.value, 'event.target.value');
        this.setState({
            ...this.state,
            pages: 0,
            pageSize: 10,
            [event.target.name]: event.target.value
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }
    onDidDismissToast(e: any) {
        this.props.setData_({ response: {}, simpleToast: false });
    }

    render() {

        const {
            alertDestroy,
            ModalShow,
            fields,
            searchText,
            data_pagin_DB,
            RegistersData,
            currencyprimary,
            currencysecondary,
            slcstatus,
            slcv_user,
            slcv_status,
            isOpenDateStart,
            isOpenDateEnd,
            DateStart,
            DateEnd,
            isOpenModalFilterDate,
            usersDB,
            loading,
            response,
            simpleToast
        } = this.state;

        let data_render_data = [];

        if (data_pagin_DB && data_pagin_DB.length > 0) {
            data_render_data = [];
            data_render_data = data_pagin_DB.map((val: any, key: any) =>
                this.render_data(val, key)
            );
        };
        return (
            <>
                <IonLoading
                    //color="light"
                    cssClass='my-custom-class'
                    isOpen={!!(loading && loading.isOpen)}
                    message={`${loading && loading.Msg ? loading.Msg : ''}`}
                />
                {
                    response && response.Msg ? (
                        <IonToast
                            isOpen={!!simpleToast}
                            color={response && (response.success == 1 || response.success == true) ? 'success' : 'danger'}
                            position='top'
                            message={`${response && response.Msg ? response.Msg : ''}`}
                            duration={1500}
                            onDidDismiss={e => this.onDidDismissToast(e)}
                        />
                    ) : null
                }
                <IonPage id="main-content">
                    <IonHeader>
                        <IonToolbar color="primary">
                            <IonButtons slot="start">
                                <IonBackButton defaultHref="/home" text={""} />
                            </IonButtons>
                            <IonTitle style={{ fontSize: "15px" }}>CAJAS</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent fullscreen scrollEvents={true} className='background'>
                        <IonRow>
                            <IonCol col-6 size='6' style={{ textAlign: "center", display: "none" }}>
                                <div style={{ display: "none" }}>
                                    <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                                </div>
                            </IonCol>
                            <IonCol size='6' col-6>
                                <label>Usuario: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'slcv_user', value: e.value } })}
                                    placeholder="Usuario"
                                    name='slcv_user'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[
                                        { label: 'Seleccione', value: null },
                                        ...(usersDB && usersDB.map((value: any) => (
                                            { label: value.name, value: value.id }
                                        )))
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={slcv_user ?
                                        usersDB && usersDB.length > 0 ?
                                            {
                                                label: usersDB.filter((item: any) => item.id == slcv_user)[0].name, value: usersDB.filter((item: any) => item.id == slcv_user)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>
                            <IonCol size='6' col-6>
                                <label>Estado: </label>
                                <Select
                                    className='inputformselect'
                                    onChange={(e: any) => this.handleChangeState({ target: { name: 'slcv_status', value: e.value } })}
                                    placeholder="Usuario"
                                    name='slcv_status'
                                    menuPortalTarget={document.querySelector('body')}
                                    isSearchable={false}
                                    options={[
                                        { label: 'Seleccione', value: null },
                                        ...(slcstatus && slcstatus.map((value: any) => (
                                            { label: value.name, value: value.id }
                                        )))
                                    ]}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                    }}
                                    defaultValue={slcv_status ?
                                        slcstatus && slcstatus.length > 0 ?
                                            {
                                                label: slcstatus.filter((item: any) => item.id == slcv_status)[0].name, value: slcstatus.filter((item: any) => item.id == slcv_status)[0].id
                                            }
                                            : { label: 'Seleccione', value: null }
                                        : { label: 'Seleccione', value: null }
                                    }
                                />
                            </IonCol>
                            <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                <IonButton
                                    expand="full"
                                    onClick={(e: any) => {
                                        e.persist();
                                        this.setState({
                                            isOpenDateStart: true,
                                            pages: 0,
                                            pageSize: 10,
                                        });
                                    }}
                                >
                                    Inicio :
                                    <Moment
                                        date={DateStart}
                                        format="DD-MM-YYYY"
                                    />
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenDateStart}
                                    onDidDismiss={() =>
                                        this.setState({
                                            isOpenDateStart: false,
                                            pages: 0,
                                            pageSize: 10,
                                        })}
                                >
                                    <IonDatetime
                                        presentation="date"
                                        value={moment(DateStart, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                        onIonChange={(e: any) => {
                                            this.setState({ DateStart: e.detail.value, isOpenDateEnd: false });
                                            setTimeout(this.getDataPaginInit.bind(this), 1000);
                                        }}
                                    ></IonDatetime>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                                <IonButton color='primary' expand="full" onClick={(e: any) => {
                                    e.persist();
                                    this.setState({ isOpenModalFilterDate: true });
                                }}>
                                    <IonIcon icon={funnel}></IonIcon>
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenModalFilterDate}
                                    onDidDismiss={() =>
                                        this.setState({ isOpenModalFilterDate: false })}
                                >
                                    <IonList inset={true}>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'hoy' } })}
                                        >
                                            <IonLabel>Hoy</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ayer' } })}>
                                            <IonLabel>Ayer</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ultimo_7' } })}>
                                            <IonLabel>Los Ultimos 7 Dias</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_mes' } })}>
                                            <IonLabel>Este Mes</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_ano' } })}>
                                            <IonLabel>Este Año</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ano_pasado' } })}>
                                            <IonLabel>El Año Pasado</IonLabel>
                                        </IonItem>
                                    </IonList>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                <IonButton
                                    expand="full"
                                    onClick={(e: any) => {
                                        e.persist();
                                        this.setState({ isOpenDateEnd: true });
                                    }}
                                >
                                    Fin :
                                    <Moment
                                        date={DateEnd}
                                        format="DD-MM-YYYY"
                                    />
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenDateEnd}
                                    onDidDismiss={() =>
                                        this.setState({ isOpenDateEnd: false })}
                                >
                                    <IonDatetime
                                        presentation="date"
                                        value={moment(DateEnd, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                        onIonChange={(e: any) => {
                                            this.setState({ DateEnd: e.detail.value, isOpenDateEnd: false });
                                            setTimeout(this.getDataPaginInit.bind(this), 1000);
                                        }}

                                    ></IonDatetime>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-12 size='12' class='divflex'>
                                <IonIcon icon={search} className='iconseach'></IonIcon>
                                <DebounceInput
                                    className='btn_search'
                                    placeholder={'Código'}
                                    minLength={2}
                                    debounceTimeout={2000}
                                    value={searchText}
                                    onChange={e => this.setSearchText(e)} />
                            </IonCol>
                            <IonCol size='12'>
                                {data_render_data}
                            </IonCol>
                            <IonModal onDidDismiss={this.dismissModalRegisterData.bind(this)} isOpen={ModalShow} ref={this.ModalShow} trigger="open-modal">
                                <IonContent className="ion-padding">
                                    <IonHeader >
                                        <IonToolbar color="primary">
                                            <IonTitle>{'CAJA'} {RegistersData && RegistersData.register_details && RegistersData.register_details.id}</IonTitle>
                                            <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalRegisterData.bind(this)}>
                                                <IonIcon icon={closeOutline}></IonIcon>
                                            </IonButton>
                                        </IonToolbar>
                                    </IonHeader>
                                    <IonRow>
                                        <IonCol size='12' className='ion-padding'>
                                            Usuario: {(RegistersData && RegistersData.register_details && RegistersData.register_details.user_name) ?? ''} <br />
                                            Email: {(RegistersData && RegistersData.register_details && RegistersData.register_details.email) ?? ''} <br />
                                            Sucursal: {(RegistersData && RegistersData.register_details && RegistersData.register_details.location_name) ?? ''} <br />
                                            Tasa de Cambio: {(RegistersData && RegistersData.register_details && RegistersData.register_details.tasa_cambio) ?? ''} <br />
                                            Creación / Cierre:
                                            {(RegistersData && RegistersData.register_details && RegistersData.register_details.open_time) ? moment(RegistersData.register_details.open_time).format('DD-MM-YYYY HH:mm') : ''}
                                            /
                                            {(RegistersData && RegistersData.register_details && RegistersData.register_details.closed_at) ? moment(RegistersData.register_details.closed_at).format('DD-MM-YYYY HH:mm') : ''}<br />
                                        </IonCol>
                                        <IonCol size='12' className='ion-padding'>
                                            {/* 
                                            
                                            {(() => {
                                                const rd = RegistersData.register_details;
                                                const operation = RegistersData.datasecondary.secondary.operation;
                                                const total_secondary = rd.total_secondary;
                                                const tasa = rd.tasa_cambio;
                                                let total_sales_secondary_to_primary = 0;

                                                if (operation === '*') {
                                                    total_sales_secondary_to_primary = total_secondary / tasa;
                                                } else {
                                                    total_sales_secondary_to_primary = total_secondary * tasa;
                                                }

                                                const ventamasprima =
                                                    (Number(rd.total_cash) || 0) +
                                                    (Number(rd.total_anticipe_payment) || 0) +
                                                    (Number(rd.total_customer_payment_prima) || 0) +
                                                    total_sales_secondary_to_primary;

                                                return _numberFormat.format(ventamasprima);
                                            })()}

                                            */}
                                            <div style={{ border: '1px solid #e6e6e6', borderRadius: 8, overflow: 'hidden', background: '#fff', marginBottom: 12 }}>
                                                <div style={{ padding: 12 }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                        <div style={{ color: '#333' }}>Abonos:</div>
                                                        <div style={{ fontWeight: 600 }}>
                                                            {_numberFormat.format((RegistersData && RegistersData.register_details && RegistersData.register_details._abonos) || 0).replace("$", currencyprimary)}
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                        <div style={{ color: '#333' }}>Ventas + Prima:</div>
                                                        <div style={{ fontWeight: 600 }}>
                                                            {_numberFormat.format((RegistersData && RegistersData.register_details && RegistersData.register_details._venta_prima) || 0).replace("$", currencyprimary)}

                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                        <div style={{ color: '#333' }}>Total:</div>
                                                        <div style={{ fontWeight: 600 }}>
                                                            {_numberFormat.format((RegistersData && RegistersData.register_details && RegistersData.register_details._total) || 0).replace("$", currencyprimary)}

                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                        <div style={{ color: '#333' }}>Desglose:</div>
                                                        <div style={{ fontWeight: 600 }}>
                                                            {_numberFormat.format((RegistersData && RegistersData.register_details && RegistersData.register_details._desglose) || 0).replace("$", currencyprimary)}
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                        <div style={{ color: '#333' }}>Diferencia:</div>
                                                        <div style={{ fontWeight: 600 }}> {_numberFormat.format((RegistersData && RegistersData.register_details && RegistersData.register_details._diferencia) || 0).replace("$", currencyprimary)}</div>
                                                    </div>
                                                    {(() => {
                                                        const payments: any[] =
                                                            (RegistersData && RegistersData.register_details && RegistersData.register_details._payments) ||
                                                            (RegistersData && RegistersData.datasecondary && RegistersData.datasecondary.secondary && RegistersData.datasecondary.secondary._payments) ||
                                                            [];

                                                        return (
                                                            <div style={{ marginTop: 8 }}>
                                                                <div style={{ fontWeight: 700, marginBottom: 8 }}>Pagos:</div>
                                                                {payments.length === 0 ? (
                                                                    <div style={{ color: '#777' }}>No hay pagos</div>
                                                                ) : (
                                                                    payments.map((p: any, idx: number) => {
                                                                        const amount = Number(p.amount) || 0;
                                                                        const tasa = RegistersData && RegistersData.register_details && Number(RegistersData.register_details.tasa_cambio);
                                                                        const operation =
                                                                            RegistersData &&
                                                                            RegistersData.datasecondary &&
                                                                            RegistersData.datasecondary.secondary &&
                                                                            RegistersData.datasecondary.secondary.operation;
                                                                        let converted: number | null = null;
                                                                        if (p.is_secondary && tasa) {
                                                                            converted = operation === '*' ? amount * tasa : amount / tasa;
                                                                        }

                                                                        return (
                                                                            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                                                <div>
                                                                                    {p.name}

                                                                                </div>
                                                                                <div style={{ textAlign: 'right' }}>
                                                                                    <div style={{ fontWeight: 600 }}>
                                                                                        {_numberFormat.format(amount).replace("$", (p.is_secondary ? currencysecondary : currencyprimary))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })
                                                                )}
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        </IonCol>
                                    </IonRow>
                                </IonContent>
                                <IonFooter collapse="fade" className='footerfixed'>
                                    <IonToolbar>
                                        <IonButtons slot="start">
                                            <IonButton color="dark" onClick={() => this.dismissModalRegisterData()}>
                                                Cancel
                                            </IonButton>
                                        </IonButtons>

                                    </IonToolbar>
                                </IonFooter>
                            </IonModal>
                        </IonRow>
                    </IonContent>
                </IonPage >
            </>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(ReportsActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ReportsActions.post_(data, controller)),
        validate_permission_: () => dispatch(UtilActions.validate_permission_()),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        get_data_module: (fields: any, controller: string) => dispatch(UtilActions.get_(fields, controller)),

        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),


    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps)(RegisterReport));
